export function calculateStrokePixels(points, canvasWidth, canvasHeight) {
    if (points.length < 2)
        return 0;
    let minX = Infinity, maxX = -Infinity;
    let minY = Infinity, maxY = -Infinity;
    for (const [x, y] of points) {
        minX = Math.min(minX, x);
        maxX = Math.max(maxX, x);
        minY = Math.min(minY, y);
        maxY = Math.max(maxY, y);
    }
    const width = (maxX - minX) * canvasWidth;
    const height = (maxY - minY) * canvasHeight;
    return Math.max(width * height, 1);
}
export function calculateStrokeLength(points, canvasWidth, canvasHeight) {
    if (points.length < 2)
        return 0;
    let length = 0;
    for (let i = 1; i < points.length; i++) {
        const [x1, y1] = points[i - 1];
        const [x2, y2] = points[i];
        const dx = (x2 - x1) * canvasWidth;
        const dy = (y2 - y1) * canvasHeight;
        length += Math.sqrt(dx * dx + dy * dy);
    }
    return length;
}
const DEFAULT_CONFIG = {
    bitsPerPx: 0.002,
    displayDurationMs: 30000,
    minBits: 100,
    maxBits: 5000,
};
export function calculateBitsCost(stroke, canvasWidth = 1920, canvasHeight = 1080, config = DEFAULT_CONFIG) {
    const { bitsPerPx, minBits, maxBits } = config;
    const area = calculateStrokePixels(stroke.points, canvasWidth, canvasHeight);
    const areaWithWidth = area + (stroke.width * stroke.width);
    const rawBits = Math.ceil(areaWithWidth * bitsPerPx);
    return Math.min(Math.max(rawBits, minBits), maxBits);
}
export function formatBitsCost(bits) {
    return `${bits} Bit${bits !== 1 ? 's' : ''}`;
}
//# sourceMappingURL=pricing.js.map